const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '不缓冲秒开',
    desc: '全球CDN加速节点覆盖，智能选择最优线路。从点击到播放仅需毫秒级响应，告别加载等待，真正实现即点即播的极致体验。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清流畅不卡顿',
    desc: '支持1080P至4K超清画质，H.265高效编码节省流量。自适应码率技术根据网络状况动态调整，确保任何环境下都能流畅观影。',
  },
  {
    icon: 'ri-movie-line',
    title: '海量片库每日更新',
    desc: '汇聚10万+影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类。内容团队每日精选30+部热门佳作入库，片库始终新鲜。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">平台特色</h2>
          <p className="text-foreground-400 text-sm">为什么千万用户选择香蕉影视</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[1000px] mx-auto">
          {featuresData.map((item, i) => (
            <div key={i} className="group p-6 rounded-xl bg-background-200/60 border border-background-300/40 hover:border-primary-500/30 transition-all duration-300 text-center">
              <div className="w-14 h-14 rounded-xl bg-primary-500/10 flex items-center justify-center mx-auto mb-4 border border-primary-500/20 group-hover:bg-primary-500/15 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="font-bold text-foreground-50 text-base mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-400 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}